import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { LoginRoutingModule , routedComponents} from './login-routing.module';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,LoginRoutingModule
    ,DropDownsModule
  ],
  declarations: [routedComponents],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ],
})
export class LoginModule { }
